<script>
  import HazardControls from './HazardControls.svelte';
  import {sgettext} from '../../i18n.js';
  export let hazard = {};

</script>

<style>
  .hazard-detail {
    display: flex;
  }

  .hazard-detail {
    flex: 1;
    border: 1px solid #dee2e6;
  }

  .icon {
    font-size: 10px;
    width: 64px;
    margin-right: 30px;
    padding: 15px;
  }

  .icon img {width: 100%;}

  .other-info {
    color: #858585;
    font-size: 14px;
  }


  section header {padding: 10px 15px; background-color: #dee2e6;}
  section header h4 {margin: 0;}
  section .detail {padding: 15px;}
</style>

<section>
  <header><h4>{sgettext('$$RISK$$')}</h4></header>
  <div class="hazard-detail">
    <div class="icon">
      {#if hazard.icon}
      <img src={hazard.icon.icon.url} alt={hazard.icon.name} />
      {/if}
    </div>
    
    <div class="detail">
      <div class="hazard-name">{hazard.name}</div>
      <div class="other-info">{sgettext('$$ENERGY_1$$')} {hazard.energy}</div>
      <div class="other-info">{sgettext('$$MECHANISM_1$$')} {hazard.mechanism}</div>
    </div>
  </div>
</section>

<HazardControls controls={hazard.controls} />
